<template>
	<div id="login">
		<div class="content">
			<el-row type="flex" justify="space-between">
				<el-col style="text-align:left;width: auto;">
					<!-- logo，介绍 -->
					<div class="logontext">
						<img src="../../assets/logo.png" alt />
						<div class="text">
							<h4>股东在线服务系统使用说明：</h4>
							<p>1、股权账户号为12位或者8位数字，老版本托管卡请输入8位股东编号</p>
							<p>2、账户密码为股东在成都托管中心设置的密码，如需修改或遗忘密码，须实名认证后办理；</p>
							<p>3、验证码请输入右边图片中的字符；</p>
							<p>4、实名认证和申请办理业务请扫描下方二维码进入成都托管中心微信公众号办理。</p>
							<div class="code" style="margin-bottom: 10px;">
								<img :src="urlimg" alt />
							</div>
							<p>提示：建议使用‘谷歌浏览器’、‘火狐浏览器’使用本网站</p>
						</div>
					</div>
				</el-col>
				<el-col style="text-align:right;width: auto;">
					<!-- 登录 -->
					<div class="loginform">
						<h3>股东在线服务系统</h3>
						<p class="texte">Shareholder Online Service System</p>
						<span class="hr"></span>
						<div class="input inputiocn" :class="numbererr?'':'err'">
							<i class="el-icon-user"></i><input type="text" v-model="number" maxlength="12" placeholder="输入股权账户号/股东编号" autocomplete="new-password" />
							<p class="inputtisp">请输入股东账号</p>
						</div>
						<div class="input inputiocn" :class="passworderr?'':'err'">
							<i class="el-icon-lock"></i><input type="password" maxlength="6" v-model="password" placeholder="输入账户密码（6位数字）" autocomplete="new-password" />
							<p class="inputtisp">请输入密码(6位数字)</p>
						</div>
						<div class="input code" :class="codevalerr?'':'err'">
							<input type="text" maxlength="4" v-model="codeval" placeholder="输入验证码" />
							<div class="codebox" @click="getcode()">
								<span class="imgbox">
									<img :src="code" alt />
								</span>
								<span class="buttonbox">
									<el-link style="font-size:12px;" type="primary">换一张</el-link>
								</span>
							</div>
							<p class="inputtisp">请输入验证码</p>
						</div>
						<div class="forget">
							<el-link style="font-size:12px" type="primary" @click="tohref">忘记密码？</el-link>
						</div>
						<div class="register">
							<el-button round class="registerbutton" @click="login" v-loading.fullscreen.lock="fullscreenLoading">登录</el-button>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div id="tisp" v-if="tispshow">
			<!-- 未实名制弹窗 -->
			<div class="centent">
				<h5>提示</h5>
				<i class="el-icon-close del" @click="tisp"></i>
				<p class="codetitle">
					<i class="el-icon-warning"></i>该账户为初始密码
				</p>
				<p class="textp">请扫描下方微信码关注微信公众号办理实名认证再登录修改初始密码后使用相关服务</p>
				<div class="code">
					<img :src="urlimg" alt />
				</div>
			</div>
		</div>
		<div id='setpass' v-if="show">
			<!-- 未实名制弹窗 -->
			<div class="centent">
				<h5>修改密码<span class="line"></span></h5>
				<i class="el-icon-close del" @click="del(2)"></i>
				<div class="inputbox">
					<el-input class="input border0 color" type="tel" autocomplete="new-password" maxlength="11" placeholder="请输入预留手机号" suffix-icon="el-icon-user-solid" readonly :value="'预留手机号：'+phone.substr(0, 3) + '****' + phone.substr(7, 11)"></el-input>
				</div>
				<div class="inputbox code">
					<el-input class="input border0" type="text" maxlength="6" autocomplete="new-password" placeholder="输入验证码" v-model="phonecode"></el-input>
					<div class="codebox getcodebox">
						<el-button round class="getcode" v-if="time==60" @click="getphonecode">获取验证码</el-button>
						<el-button round class="getcode" v-else type="button">{{time}}s后重新获取</el-button>
					</div>
				</div>
				<div class="inputbox" :class="passw1err?'':'err'">
					<el-input class="input border0" maxlength="6" autocomplete="new-password" type="password" placeholder="输入新密码(6位不重复数字)" v-model="passw1"><i slot="suffix" class="passwordimg"></i></el-input>
					<p class="inputtisp">新密码需为6位不重复数字</p>
				</div>
				<div class="inputbox" :class="passw2err?'':'err'">
					<el-input class="input border0" maxlength="6" autocomplete="new-password" type="password" placeholder="再次输入新密码" v-model="passw2"><i slot="suffix" class="passwordimg"></i></el-input>
					<p class="inputtisp">新密码需为6位不重复数字</p>
				</div>
				<div class="inputbox">
					<el-button round class="registerbutton" @click="submin()">确定</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axiosPost from "../../libs/moudle/index.js";
	import {
		url
	} from "../../libs/api/index.js";
	export default {
		data() {
			return {
				urlimg: require("../../assets/ma.jpg"),
				code: "",
				codetext: "",
				codeval: "",
				codeshow: false, //公众号二维码
				tispshow: false, //登录提示
				number: "",
				/* 账号 */
				password: "",
				/*, 密码 */
				fullscreenLoading: false,
				show: false,
				phone: '',
				phonecode: '',
				passw1: '',
				passw1err: true,
				passw2: '',
				passw2err: true,
				time: 60,
				cleattime: '',
				numbererr: true,
				passworderr: true,
				codevalerr: true,
			};
		},
		watch: {
			tispshow() {
				this.time = 60;
			},
			password(val) {
				if (val == '' || isNaN(val)) {
					this.passworderr = false
				} else {
					this.passworderr = true
				}
			},
			codeval(val) {
				if (val == '') {
					this.codevalerr = false
				} else {
					this.codevalerr = true
				}
			},
			number(val) {
				if (val == '') {
					this.numbererr = false
				} else {
					this.numbererr = true
				}
			},
			passw1(val) {
				let ispass = false
				for (let i = 0, len = val.length; i < len; i++) {
					for (let j = 0, lenj = val.length; j < lenj; j++) {
						if (val[i] != val[j]) {
							ispass = true;
							break;
						}
					}
				}
				if (val.length == 6 && ispass && !isNaN(val)) { /* 格式满足 */
					this.passw1err = true
				} else {
					this.passw1err = false
				}
			},
			passw2(val) {
				let ispass = false
				for (let i = 0, len = val.length; i < len; i++) {
					for (let j = 0, lenj = val.length; j < lenj; j++) {
						if (val[i] != val[j]) {
							ispass = true;
							break;
						}
					}
				}
				if (val.length == 6 && ispass && !isNaN(val)) { /* 格式满足 */
					this.passw2err = true
				} else {
					this.passw2err = false
				}
			}
		},
		methods: {
			qrcode() {
				//公众号弹窗
				this.codeshow = !this.codeshow;
			},
			tisp() {
				this.tispshow = !this.tispshow;
			},
			getphonecode() { /* 获取短信验证码 */
				let user = this.number
				if (user.length < 12) {
					let len = user.length;
					for (let i = 1; i < (12 - len); i++) {
						user = '0' + user;
					}
					user = '9' + user
				}
				axiosPost.getphone({
					phone: this.phone,
					shareholderCode: user
				}).then((res) => {
					window.console.log(res)
					if (res.data.code == 200) {
						this.$message.warning({
							showClose: true,
							message: '验证码已发送到手机，请注意查收！',
							duration: 5000,
						});
						this.settime();
					} else {
						this.$message.error({
							showClose: true,
							message: res.data.msg,
							duration: 5000,
						});
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			settime() {
				let t = this;
				this.cleattime = setInterval(function() {
					t.time--;
					if (t.time == 0) {
						t.time = 60;
						clearInterval(t.cleattime)
					}
				}, 1000)
			},
			submin() { /* 密码重置提交 */
				let t = this;
				let user = this.number
				if (user.length < 12) {
					let len = user.length;
					for (let i = 1; i < (12 - len); i++) {
						user = '0' + user;
					}
					user = '9' + user
				}
				if (t.phonecode == "") {
					this.$message.warning({
						showClose: true,
						message: '请输入验证码！',
						duration: 5000,
					});
					return false
				}
				if (t.passw1 != t.passw2) {
					this.$message.warning({
						showClose: true,
						message: '两次新密码不一致，请重新输入！',
						duration: 5000,
					});
					return false
				}
				if (!this.passw1err || !this.passw2err || this.passw1 == '') {
					this.passw1err = false
					this.passw2err = false
					return false;
				}
				let params = '4900;' + user + ';222222;' + t.passw1 + ';;;;'
				axiosPost.getdata(params, t.code).then((res) => {
					let str = res.data.data
					if (res.data.filter && res.data.filter.msg) {
						this.$alert(res.data.filter.msg, '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.console.log(action);
								if (res.data.filter.code == 0) {
									share()
								}else{
									this.$router.push({
										path: "/login"
									});
								}
							}
						});
					}else{
						share()
					}
					function share(){
						if (res.data.code == 200) {
							let code = str.slice(0, str.indexOf(';'))
							if (code == 200) {
								t.$message.warning({
									showClose: true,
									message: '密码修改成功,请重新登录！',
									duration: 5000,
								});
								t.number = '';
								t.password = '';
								t.show = false;
							} else if (code == 400) {
								t.$message.error({
									showClose: true,
									message: '原密码错误，请重新输入！',
									duration: 5000,
								});
								t.getcode();
							} else {
								t.$message.error({
									showClose: true,
									message: str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3) + '，请稍后再试！',
									duration: 5000,
								});
								t.getcode();
							}
						} else {
							t.$message.error({
								showClose: true,
								message: res.data.msg,
								duration: 5000,
							});
						}
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			login() {
				let t=this;
				this.fullscreenLoading = true;
				if (this.number == "") {
					this.numbererr = false;
				}
				if (this.password == "") {
					this.passworderr = false;
				}
				if (this.codeval == "") {
					this.codevalerr = false;
				}
				if (!this.codevalerr || !this.passworderr || !this.numbererr) {
					this.fullscreenLoading = false;
					return false;
				}
				if (this.codeval.toUpperCase() != this.codetext.toUpperCase()) {
					this.$message.error({
						showClose: true,
						message: '验证码不正确！',
						duration: 5000,
					});
					this.fullscreenLoading = false;
					this.getcode();
					return false;
				}
				let params = "2904";
				let number = this.number;
				if (number.length < 12) {
					let len = number.length;
					for (let i = 1; i < 12 - len; i++) {
						number = "0" + number;
					}
					number = "9" + number;
				}
				params += ";" + number + ";" + this.password + ";;;;;";

				axiosPost
					.getdata(params)
					.then(res => {
						this.fullscreenLoading = false;
						if (res.data.filter && res.data.filter.msg) {
							this.$alert(res.data.filter.msg, '提示', {
								confirmButtonText: '确定',
								callback: action => {
									window.console.log(action);
									if (res.data.filter.code == 0) {
										share()
									}else{
										this.$router.push({
											path: "/login"
										});
									}
								}
							});
						}else{
							share()
						}
						
						function share(){
							if (res.data.code == 200) {
								let str = res.data.data;
								// 登录
								let code = str.slice(0, str.indexOf(";"));
								let result='';
								if (code == 200) {
									axiosPost
										.getShare({
											shareholderCode: number
										})
										.then(res => {
											/* 验证是否实名认证 */
											window.console.log(res);
											if (!res.data.data || !res.data.data.authenticationStatus || res.data.data.authenticationStatus == 0) {
												if (t.password == 222222) {
													/* 提示验证 */
													t.tisp();
												} else {
													/* 正常 */
													sessionStorage.setItem("information", str.slice(str.indexOf(";") + 1, str.indexOf("\r") - 3));
													t.$router.push({
														path: "/index"
													});
												}
											} else {
												/* 实名了 */
												if (t.password == 222222) {
													/* 需要修改密码 */
													t.$message.warning({
														showClose: true,
														message: '该账户为初始密码，请修改初始密码后使用相关服务！',
														duration: 10000,
													});
													t.phone = res.data.data.phone
													t.show = true;
												} else {
													/* 正常 */
													sessionStorage.setItem("information", str.slice(str.indexOf(";") + 1, str.indexOf("\r") - 3));
													t.$router.push({
														path: "/index"
													});
												}
											}
										})
										.catch(res => {
											window.console.log(res);
										});
								} else if (code == 400) {
											// eslint-disable-next-line no-unused-vars
											let strt="密码有误";
											// eslint-disable-next-line no-undef
											if(res.data.data.indexOf(strt)!=-1){
												// eslint-disable-next-line no-redeclare
											result = "账号或密码不正确 ，请确认后重新登录"
											
											}else{
												// eslint-disable-next-line no-unused-vars
												// let search ='数据查询超时，请稍后再试！'
												// eslint-disable-next-line no-unused-vars
												// let start = res.data.data.indexOf(search);//获得字符串的开始位置
												// eslint-disable-next-line no-unused-vars
												result = str.slice(str.indexOf(';') + 1, str.indexOf('\\r') ) ;//截取字符串
											}
									t.$message.error({
										showClose: true,
										message: result,
										duration: 5000,
									});
									t.getcode();
								} else {
									/* 错误 */
									t.$message.error({
										showClose: true,
										message: str.slice(str.indexOf(';') + 1, str.indexOf('\r') ) + '，请稍后再试！',
										duration: 5000,
									});
									t.getcode();
								}
							} else {
								t.$message.error({
									showClose: true,
									message: res.data.msg,
									duration: 5000,
								});
							}
						}
					})
					.catch(res => {
						window.console.log(res);
					});
			},
			tohref() {
				this.$router.push({
					path: "/ForgetPassword"
				});
			},
			getcode() {
				axiosPost
					.getcode("")
					.then(res => {
						if (res.data.code == 200) {
							this.code = url + "app/file/downByTmpPath?path=" +
								res.data.data.path;
							this.codetext = res.data.data.validCode;
						} else {
							this.$message.error(res.data.msg);
						}
					})
					.catch(res => {
						window.console.log(res);
					});
			}
		},
		mounted() {
			this.getcode();
		}
	};
</script>

<style lang="less" scoped>
	#modify {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, .5);
		display: flex;
		align-items: center;
		justify-content: center;

		.el-input__inner:focus {
			border-color: red;
		}

		.registerbutton {
			font-size: 14px;
			background-color: #d9261c;
			color: #fff;
			width: 100%;
			border: 0px;
		}

		.err.inputbox {
			.input {
				border: 1px solid #f56c6c;
			}

			.inputtisp {
				text-align: left;
				font-size: 12px;
				color: #f56c6c;
				margin: 0;
				position: absolute;
				bottom: 8px;
				left: 15px;
			}
		}

		.inputbox {
			padding-bottom: 25px;
			position: relative;

			.input {
				border-radius: 100px;
				overflow: hidden;
				box-sizing: border-box;
				border: 1px solid transparent;
			}

			.passwordimg {
				display: block;
				background: url('../../assets/password.png') no-repeat center;
				background-size: 13px 13px;
				width: 25px;
				height: 100%;
			}
		}

		.input:focus {
			border: 20px solid red;
		}

		h5 {
			font-size: 20px;
			text-align: center;
			color: #333333;
			font-weight: 500;
			position: relative;
			margin-top: 0;

			.line {
				position: absolute;
				bottom: -10px;
				left: 50%;
				margin-left: -15px;
				display: block;
				width: 30px;
				height: 3px;
				border-radius: 5px;
				background-color: #d9261c;
			}
		}

		.del {
			position: absolute;
			top: 20px;
			right: 20px;
			font-size: 24px;
			color: #777777;
			cursor: pointer;
		}

		.centent {
			position: relative;
			background-color: #fff;
			padding: 15px;
			border-radius: 5px;
			width: 360px;
			font-size: 0;
			padding: 30px;
			background-color: #fff;
			border-radius: 8px;
			text-align: center;
		}
	}

	.logontext {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		img {
			width: 227px;
			height: 60px;
		}

		.text {
			font-size: 14px;
			color: #fff;

			p {
				margin: 10px 0;
			}

			span {
				color: #c96e39;
				text-decoration: underline;
				cursor: pointer;
			}
		}

		.code {
			width: 110px;
			height: 110px;
			padding: 3px;
			margin-top: 20px;
			background-color: #fff;
			border: 2px solid #bdc8da;
			box-shadow: 0 0 0px 2px #fff;
			font-size: 0;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.register {
		text-align: center;
		margin-top: 30px;

		.registerbutton {
			font-size: 14px;
			background-color: #d9261c;
			color: #fff;
			width: 60%;
			border: 0px;
		}
	}

	.input {
		margin-bottom: 30px;

		input {
			border: 0;
			border-bottom: 1px solid #e0e0e0;
			width: 100%;
			height: 40px;
			font-size: 12px;
			padding: 0 10px;
		}
	}

	.err.inputiocn {
		border-bottom: 1px solid #f56c6c;

		.inputtisp {
			text-align: left;
			font-size: 12px;
			color: #f56c6c;
			margin: 0;
			position: absolute;
			bottom: -20px;
			left: 0;
		}
	}

	.inputiocn {
		margin-bottom: 30px;
		border-bottom: 1px solid #e0e0e0;
		position: relative;

		input {
			border: 0;
			width: 95%;
			height: 40px;
			font-size: 12px;
			padding: 0 10px;
		}

		.inputtisp {
			font-size: 0;
		}

		i {
			vertical-align: middle;
		}
	}

	.err.code {
		input {
			border-bottom: 1px solid #f56c6c;
		}

		.inputtisp {
			text-align: left;
			font-size: 12px;
			color: #f56c6c;
			margin: 0;
			position: absolute;
			bottom: -20px;
			left: 0;
		}
	}

	.code {
		position: relative;

		input {
			width: 55%;
			padding-left: 0;
		}

		.inputtisp {
			font-size: 0;
		}

		.codebox {
			display: inline-block;
			width: 45%;
			text-align: center;
			vertical-align: bottom;
			cursor: pointer;

			.imgbox {
				width: 80px;
				display: inline-block;
				border: 1px solid #f1f1f1;
				text-align: center;
				font-size: 0;

				img {
					width: 95%;
					margin: 2px 0;
				}
			}

			.buttonbox {
				display: inline-block;
				margin-left: 13px;
				vertical-align: 12px;
			}
		}
	}

	.loginform {
		width: 400px;
		background-color: #fff;
		border-radius: 5px;
		overflow: hidden;
		padding: 30px 40px;
		display: inline-block;
		text-align: left;

		h3 {
			font-size: 20px;
			margin: 0;
			margin-bottom: 5px;
		}

		.texte {
			color: #999999;
			font-size: 14px;
			margin: 0;
			margin-bottom: 15px;
		}

		.hr {
			display: block;
			width: 40px;
			height: 3px;
			border-radius: 10px;
			background-color: #d9261c;
			margin-bottom: 20px;
		}
	}

	#login {
		background: url("../../assets/loginbackground.png") no-repeat center !important;
		background-size: 100% 100%;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		position: absolute;
		justify-content: center;

		.content {
			max-width: 100%;
			width: 1500px;
			padding: 0 90px;
		}
	}

	#tisp {
		background-color: rgba(0, 0, 0, 0.56);
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;

		h5 {
			font-size: 22px;
			text-align: center;
			color: #fff;
			font-weight: 500;
		}

		.del {
			position: absolute;
			top: 20px;
			right: 20px;
			font-size: 24px;
			color: rgba(255, 255, 255, 0.7);
			cursor: pointer;
		}

		.centent {
			position: absolute;
			width: 380px;
			height: 350px;
			top: 50%;
			left: 50%;
			margin-top: -190px;
			margin-left: -175px;
			font-size: 0;
			background-color: rgba(255, 255, 255, 0.3);
			border-radius: 8px;
			text-align: center;

			.codetitle {
				font-size: 14px;
				color: #fff;
			}

			.textp {
				font-size: 16px;
				color: #fff;
				padding: 0 30px;
			}

			.code {
				width: 110px;
				height: 110px;
				margin: 0 auto;
				padding: 4px;
				margin-top: 30px;
				background-color: #fff;
				border: 3px solid #bdc8da;
				box-shadow: 0 0 0px 4px #fff;
				font-size: 0;

				img {
					width: 100%;
				}
			}
		}
	}

	#setpass {
		background-color: rgba(0, 0, 0, .56);
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;

		.registerbutton {
			font-size: 14px;
			background-color: #d9261c;
			color: #fff;
			width: 100%;
			border: 0px;
		}

		h5 {
			font-size: 22px;
			text-align: center;
			color: #fff;
			font-weight: 500;
			position: relative;

			.line {
				position: absolute;
				bottom: -10px;
				left: 50%;
				margin-left: -15px;
				display: block;
				width: 30px;
				height: 3px;
				border-radius: 5px;
				background-color: #d9261c;
			}
		}

		.del {
			position: absolute;
			top: 20px;
			right: 20px;
			font-size: 24px;
			color: rgba(255, 255, 255, .7);
			cursor: pointer;
		}

		.centent {
			position: absolute;
			width: 380px;
			top: 50%;
			left: 50%;
			transform: translateY(-50%);
			margin-left: -175px;
			font-size: 0;
			padding: 0 30px;
			background-color: rgba(255, 255, 255, .3);
			border-radius: 8px;
			text-align: center;
		}

		.code {
			.input {
				width: 55%;
			}

			.codebox {
				display: inline-block;
				width: 45%;
				text-align: center;
				height: 30px;
				vertical-align: 21px;
				cursor: pointer;

				.imgbox {
					width: 80px;
					text-align: center;
					font-size: 0;
					background-color: #fff;
					border-radius: 3px;
					display: inline-block;
					vertical-align: middle;

					img {
						width: 95%;
						margin: 2px 0;
					}
				}

				.buttonbox {
					display: inline-block;
					margin-left: 15px;
					vertical-align: middle;
				}
			}

			.getcodebox {
				vertical-align: 15px;
				text-align: right;
			}

			.getcode {
				color: #fff;
				background-color: #999999;
				padding-left: 15px;
				padding-right: 15px;
			}
		}

		.err.inputbox {
			.input {
				border: 1px solid #f56c6c;
				margin-bottom: 0;
			}

			.inputtisp {
				text-align: left;
				font-size: 12px;
				color: #f56c6c;
				margin: 0;
				position: absolute;
				bottom: 8px;
				left: 15px;
			}
		}

		.inputbox {
			padding-bottom: 25px;
			position: relative;

			.input {
				border-radius: 100px;
				overflow: hidden;
				box-sizing: border-box;
				border: 1px solid transparent;
				margin-bottom: 0;
			}

			.passwordimg {
				display: block;
				background: url('../../assets/password.png') no-repeat center;
				background-size: 13px 13px;
				width: 25px;
				height: 100%;
			}
		}

		.input:focus {
			border: 20px solid red;
		}
	}
</style>
